import { DeviceLogs } from 'components/DeviceLogs';
import { Sites } from 'components/Sites';
import SiteDetails from 'components/SiteDetails';
import DeviceDetails from 'components/DeviceDetails';
import Installers from 'components/Users/Installers';
import Companies from 'components/Users/Companies';
import Customers from 'components/Users/Customers';
import { Logout } from 'components/Users/Logout';
import Profile from 'components/Users/Profile';
import EditUserProfile from 'components/Users/Profile/EditUserProfile';
import EditDevices from 'components/DeviceDetails/EditDevices';
import AddSites from 'components/Sites/AddSites';
import AddDevice from 'components/SiteDetails/AddDevice';
import AddMicroinverters from 'components/DeviceDetails/AddMicroinverters';
import EditSite from 'components/SiteDetails/EditSite';
import EditDeviceProfile from 'components/DeviceDetails/EditDeviceProfile';
import UpgradeHistory from 'components/DeviceDetails/UpgradeHistory';
import UpgradeLogDetails from 'components/DeviceDetails/UpgradeHistory/UpgradeLogDetails';
import WarrantyList from 'components/WarrantyList';
import {
    ClipboardDocumentListIcon,
    MapPinIcon,
    WrenchScrewdriverIcon,
    BuildingOfficeIcon,
    UserGroupIcon,
} from '@heroicons/react/24/outline';

export const NotFoundPage = () => {
    return (
        <div className="mt-[88px] text-center align-middle">
            <h1>404 - Not Found!</h1>
        </div>
    );
};

const routes = [
    {
        name: 'Warranties',
        key: 'warranties',
        icon: <ClipboardDocumentListIcon className="w-5 h-5" />,
        route: '/warranties',
        component: <WarrantyList />,
        requireAdmin: true,
    },
    {
        name: 'Sites',
        key: 'sites',
        icon: <MapPinIcon className="w-5 h-5" />,
        route: '/sites',
        component: <Sites />,
        requireInstaller: true,
        hideForAdmin: true,
    },
    {
        name: 'Installers',
        key: 'installers',
        icon: <WrenchScrewdriverIcon className="w-5 h-5" />,
        route: '/installers',
        component: <Installers />,
        requireCompanyAdmin: true,
    },
    {
        name: 'Companies',
        key: 'companies',
        icon: <BuildingOfficeIcon className="w-5 h-5" />,
        route: '/companies',
        component: <Companies />,
        requireCompanyAdmin: true,
    },
    {
        name: 'Customers',
        key: 'customers',
        icon: <UserGroupIcon className="w-5 h-5" />,
        route: '/customers',
        component: <Customers />,
        requireCompanyAdmin: true,
        hideForCompanyAdmin: true,
    },
    {
        name: 'Profile',
        key: 'profile',
        route: '/profile',
        component: <Profile />,
        hidden: true,
    },
    {
        name: 'Edit Profile',
        key: 'edit-profile',
        route: '/profile/edit',
        component: <EditUserProfile />,
        hidden: true,
    },
    {
        name: 'Logout',
        key: 'logout',
        route: '/logout',
        component: <Logout />,
        hidden: true,
    },
    {
        name: 'Site Details',
        key: 'site-details',
        route: '/sites/:id',
        component: <SiteDetails />,
        hidden: true,
    },
    {
        name: 'Device Logs',
        key: 'device-logs-ems',
        route: '/devices/:id/logs',
        component: <DeviceLogs />,
        hidden: true,
    },
    {
        name: 'Device Logs',
        key: 'device-logs',
        route: '/devices/:id/:BMS_ID/logs',
        component: <DeviceLogs />,
        hidden: true,
    },
    {
        name: 'Device Logs',
        key: 'device-logs',
        route: '/devices/:id/:BMS_ID/:Module_ID/logs',
        component: <DeviceLogs />,
        hidden: true,
    },
    {
        name: 'Device Details',
        key: 'device-details',
        route: '/devices/:id',
        component: <DeviceDetails />,
        hidden: true,
    },
    {
        name: 'Firmware Upgrade History',
        key: 'upgrade-history',
        route: '/devices/:id/upgrade-history',
        component: <UpgradeHistory />,
        hidden: true,
    },
    {
        name: 'Firmware Upgrade Log Details',
        key: 'upgrade-log-details',
        route: '/devices/:id/upgrade-history/:UpdateID',
        component: <UpgradeLogDetails />,
        hidden: true,
    },
    {
        name: 'BMS Details',
        key: 'bms-details',
        route: '/devices/:id/:BMS_ID',
        component: <DeviceDetails />,
        hidden: true,
    },
    {
        name: 'Edit BMS Profile',
        key: 'edit-bms-profile',
        route: '/devices/:id/:BMS_ID/edit-device-profile',
        component: <EditDeviceProfile />,
        hidden: true,
    },
    {
        // For Single Stack BMS Profiles
        name: 'Edit Single Stack BMS Profile',
        key: 'edit-single-stack-bms-profile',
        route: '/devices/:id/edit-device-profile',
        component: <EditDeviceProfile />,
        hidden: true,
    },
    {
        name: 'Module Details',
        key: 'module-details',
        route: '/devices/:id/:BMS_ID/:Module_ID',
        component: <DeviceDetails />,
        hidden: true,
    },
    {
        name: 'Edit Module Profile',
        key: 'edit-module-profile',
        route: '/devices/:id/:BMS_ID/:Module_ID/edit-module-profile',
        component: <EditDeviceProfile />,
        hidden: true,
    },
    {
        // For single stack Module Profiles
        name: 'Edit Single Stack Module Profile',
        key: 'edit-single-stack-module-profile',
        route: '/devices/:id/:BMS_ID/edit-module-profile',
        component: <EditDeviceProfile />,
        hidden: true,
    },
    {
        name: 'Add Site',
        key: 'add-site',
        route: '/sites/add-site',
        component: <AddSites />,
        hidden: true,
    },
    {
        name: 'Add Device',
        key: 'add-device',
        route: '/sites/:id/add-device',
        component: <AddDevice />,
        hidden: true,
    },
    {
        name: 'Add Microinverters',
        key: 'add-microinverters',
        route: '/devices/:id/add-microinverters',
        component: <AddMicroinverters />,
        hidden: true,
    },
    {
        name: 'Edit Site',
        key: 'edit-site',
        route: '/sites/:id/edit-site',
        component: <EditSite />,
        hidden: true,
    },
    {
        name: 'Edit Devices',
        key: 'edit-devices',
        route: '/devices/:id/edit-devices',
        component: <EditDevices />,
        hidden: true,
    },
    {
        name: 'Edit Device Profile',
        key: 'edit-device-profile',
        route: '/devices/:id/edit-device-profile',
        component: <EditDeviceProfile />,
        hidden: true,
    },
    {
        name: 'Not Found',
        key: 'not-found',
        route: '/not-found',
        component: <NotFoundPage />,
        hidden: true,
    },
    {
        name: 'Home',
        key: 'home',
        route: '/',
        component: <Sites />,
        hidden: true,
    },
];

export default routes;
